import React from "react";
import PropTypes from "prop-types";
import { View, Text } from "@react-pdf/renderer";

import { roundToPoint } from "../../../helpers/formatter";

import MetricRange from "./MetricRange";

import { demographicStyles as styles } from "./demographic.styles";

const Card = ({ data, index }) => {
  function getMax(arr) {
    if (arr.length) {
      return arr.reduce((acc, { value }) => {
        if (acc < value) {
          return value;
        }

        return acc;
      }, 0);
    }

    return 0;
  }
  const maxValue = getMax(data.data);

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Text style={styles.title}>{data.name}</Text>
        <View style={styles.line}></View>
      </View>
      <View style={styles.metricsList}>
        {data.data
          ? data.data.map((metric, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <View style={styles.metric} key={`${index}-${i}`}>
                  <Text style={styles.metricTitle}>{metric.text}</Text>
                  <View style={styles.metricRange}>
                    <MetricRange
                      value={metric.value}
                      maxValue={maxValue > 200 ? maxValue : 200}
                    />
                  </View>
                  <Text style={styles.metricValue}>
                    {roundToPoint(metric.value)}
                  </Text>
                </View>
              );
            })
          : null}
      </View>
    </View>
  );
};

Card.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string
  }).isRequired,
  index: PropTypes.string.isRequired
};

export default Card;
